import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { WORKSPACE, type WorkspaceStateType } from "./types";

const initialWorkspaceState: WorkspaceStateType = {
	collection: {
		data: [],
		error: null,
		loading: true, // start with loading state to avoid flash
	},
	member: {
		data: null,
		error: null,
		loading: true, // start with loading state to avoid flash
		processing: false,
	},
};

export const workspaceSlice = createSlice({
	name: WORKSPACE,
	initialState: initialWorkspaceState,
	reducers: {
		// Get workspace collection
		requestGetWorkspaces: (state: WorkspaceStateType) => {
			state.collection = {
				...state.collection,
				loading: true,
			};
		},
		receiveGetWorkspaces: (state: WorkspaceStateType, { payload }: PayloadAction<Workspace[]>) => {
			state.collection = {
				...state.collection,
				data: payload.map(({ id, name }) => ({ id, name })),
				loading: false,
			};
		},
		failedGetWorkspaces: (state: WorkspaceStateType, { payload }: PayloadAction<Error>) => {
			state.collection = {
				...state.collection,
				error: payload.message,
				loading: false,
			};
		},

		// Set current workspace
		requestSetCurrentWorkspace: (state: WorkspaceStateType) => {
			state.member = {
				...state.member,
				error: null,
			};
		},
		receiveSetCurrentWorkspace: () => {
			window.location.reload();
		},
		failedSetCurrentWorkspace: (state: WorkspaceStateType, { payload }: PayloadAction<Error>) => {
			state.member = {
				...state.member,
				error: payload.message,
			};
		},
	},
});

const actions = workspaceSlice.actions;
const workspaceReducer = workspaceSlice.reducer;

export { actions, workspaceReducer };
